import { Box, Container } from '@mui/material'
import PropTypes from 'prop-types'

const PanelBox = ({ children }) => {
    return (
        <Container component='main' maxWidth='xl'>
            <Box marginTop={5}>
                {children}
            </Box>
        </Container>
    )
}

PanelBox.propTypes = {
    children: PropTypes.node.isRequired
}

export default PanelBox